import {useMutation} from '@apollo/react-hooks'
import gql from 'graphql-tag'
import {useQuery} from 'react-apollo'

import {
  ACCOUNTS_QUERY,
  TRANSACTIONS_CLIENT_QUERY,
  WITHDRAWAL_FIELDS_FRAGMENT,
} from '../../../../graphql/queries'
import {VIDEO_VERIFICATION_QUERY} from '../../../../videoVerification/hooks'
import {CreatedWithdrawal, CreateWithdrawalItem} from './types'

const CREATE_WITHDRAWAL_REQUESTS_MUTATION = gql`
  ${WITHDRAWAL_FIELDS_FRAGMENT}
  mutation ($items: [CreateWithdrawalRequestInputType!]!) {
    createWithdrawalRequests(items: $items) {
      ...WithdrawalFields
      holdCode
      account {
        __typename
        ... on BaseAccount {
          id
          remoteId
          accountName
          connectedBrokereeProviderAccount {
            id
            remoteId
          }
        }
      }
    }
  }
`

function useCreateWithdrawalsRequest() {
  const [mutation, {loading}] = useMutation(CREATE_WITHDRAWAL_REQUESTS_MUTATION, {
    refetchQueries: [
      {query: ACCOUNTS_QUERY},
      {query: TRANSACTIONS_CLIENT_QUERY},
      {query: VIDEO_VERIFICATION_QUERY},
    ],
  })
  // The created withdrawals tell the caller which of them are held for the video verification.
  const createWithdrawalRequests = async (
    items: CreateWithdrawalItem[],
  ): Promise<CreatedWithdrawal[]> => {
    const result = await mutation({variables: {items}})
    return result?.data?.createWithdrawalRequests ?? []
  }

  return {createWithdrawalRequests, loading}
}

const FETCH_CLIENT_DEPOSIT_METHOD_ISSUE_VERIFICATION = gql`
  query {
    viewer {
      ... on Client {
        id
        depositMethodIssueVerifications {
          id
          accountId
          clientId
          paymentMethodOptionId
          fileUrl
          comment
          internalRemark
          processStatus
          meta
          createdAt
          updatedAt
          __typename
        }
      }
    }
  }
`

function useFetchClientDepositMethodIssueVerifications(clientId) {
  const {loading, data} = useQuery(FETCH_CLIENT_DEPOSIT_METHOD_ISSUE_VERIFICATION, {
    variables: {id: clientId}
  })

  const depositMethodIssueVerifications = data?.viewer?.depositMethodIssueVerifications || []

  return {
    depositMethodIssueVerifications,
    loading
  }
}

export {
  useCreateWithdrawalsRequest,
  useFetchClientDepositMethodIssueVerifications,
  FETCH_CLIENT_DEPOSIT_METHOD_ISSUE_VERIFICATION
}
